import { config } from "config";

type ServiceSchemaProps = {
  serviceType: string;
  description: string;
};

export function generateProductJsonLd({ serviceType, description, url }: ServiceSchemaProps & { url: string }) {
  return {
    "@context": "https://schema.org",
    "@type": "Product",
    "@id": url,
    name: serviceType,
    brand: {
      "@type": "Organization",
      name: "Agilie - Software development company",
    },
    url,
    description,
    aggregateRating: {
      "@type": "AggregateRating",
      ratingValue: 5,
      reviewCount: 18,
      bestRating: 5,
      worstRating: 1,
    },
  };
}